import React from 'react';
import { Modal, message, Row, Table, Space } from 'antd';
import { TagOutlined, FormOutlined, TransactionOutlined } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';
import SwitchShop from '../../shop/switch-shop';
import getCurrentShop from '../../shop/get-current-shop';
import dayjs from 'dayjs';
import usePagination from '../../../components/pagination';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [groups, setGroups] = React.useState([]);
    const [currentShop, setCurrentShop] = React.useState(null);
    const [currentShopId, setCurrentShopId] = React.useState(null);
    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            getGroups(page, pageSize);
        },
    });

    React.useEffect(() => {
        const fetchShop = async () => {
            const shop = await getCurrentShop();
            setCurrentShop(shop);
            setCurrentShopId(shop?.shopId);
        };
        
        fetchShop();
    }, []);
    
    React.useEffect(() => {
        if (currentShopId) {
            getGroups();
        }
    }, [currentShopId]);

    const columns = [
        {
            title: '团购名称',
            dataIndex: 'title',
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: (text) => {
                const statusMap = {
                    0: '等待开始',
                    1: '进行中',
                    2: '已结束',
                }
                return statusMap[text];
            }
        },
        {
            title: '创建于',
            dataIndex: 'createTime',
            render: (text) => {
                return dayjs(text).format("YYYY-MM-DD HH:mm");
            }
        },
        {
            title: '操作',
            dataIndex: 'operation',
            fixed: 'right',
            render: (text, record) => {
                return (
                    <div style={{width: '30px'}}>
                        <a href={`/promotion/group-buy/create?view=1&groupTmpId=${record.groupTmpId}&shopId=${currentShopId}`}>查看</a>
                        {/* {record.status === 0 && <a style={{marginRight: '8px'}} href={`/promotion/group-buy/create?groupTmpId=${record.groupTmpId}&shopId=${currentShopId}`}>编辑</a>} */}
                        {record.status !== 2 && <a onClick={() => onEndClick(record.groupTmpId)}>结束</a>}
                    </div>
                )
            }
        }
    ]

    const getGroups = async (page = 1, pageSize = 10) => {
        const url = `/api/promotion/group-buy-template/list?shopId=${currentShopId}&page=${page}&pageSize=${pageSize}`;

        const response = await fetch(url);
        const result = await response.json();

        if(result && result.success) {
            setTotal(result?.data?.count || 0);
            setGroups(result?.data?.rows || []);
        }
    }

    const onEndClick = async (groupTmpId) => {
        Modal.confirm({
            title: '结束团购',
            content: '确定要结束该团购吗？',
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                endGroupBuy(groupTmpId);
            }
        })
    }

    const endGroupBuy = async (groupTmpId) => {
        const url = `/api/promotion/group-buy-template/stop`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                groupTmpId,
                shopId: currentShopId,
            }),
        });
        const result = await response.json();
        if(result && result.success) {
            message.success('团购结束成功');
            getGroups();
        }
    }

    return (
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/promotion/group-buy/create" text="创建团购">
                    <FormOutlined style={iconStyle} />
                </NavItem>
            </Row>
            <h2>团购模版列表</h2>
            <Table rowKey='groupTmpId' dataSource={groups} columns={columns} pagination={pagination} scroll={{ x: 'max-content' }} />
        </div>
    )
}